var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"breadcrumb fn-ui-breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('div',{staticClass:"ellipsis-container"},[_c('a',{class:['breadcrumb-ellipsis', {'hover':_vm.active}],attrs:{"href":"#"}},[_c('icon',{attrs:{"icon":"ellipsis-h"}})],1)])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }